import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { IpnDetailsTabContent } from '@/areas/components/IpnDetailsPage/components/IpnDetailsTabController';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/components/ipn/_details/linking')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({
        ipnId: 'required',
        rawSpecId: 'optional',
        'part-search': 'optional',
        'custom-part-search': 'optional',
    }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const ipnId = Route.useSearch({ select: (search) => search.ipnId });
    const rawSpecId = Route.useSearch({ select: (search) => search.rawSpecId });
    return <IpnDetailsTabContent tab={'linking'} ipnId={ipnId} rawSpecId={rawSpecId} />;
}
